function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M578.14,143.4a11.25,11.25,0,1,0,11.25,11.25A11.251,11.251,0,0,0,578.14,143.4Zm4.331,16.887a1.294,1.294,0,1,1,1.294-1.294A1.294,1.294,0,0,1,582.472,160.289Zm1.294-5.006a1.294,1.294,0,1,1-2.588,0v-.619a3.038,3.038,0,1,0-3.038,3.038h.056a1.294,1.294,0,1,1,0,2.588h-.056a5.625,5.625,0,1,1,5.625-5.625Z",
  transform: "translate(-566.89 -143.402)",
  fill: "#b1b1b1"
});

var SvgDefaultIcon = function SvgDefaultIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22.501,
    height: 22.5,
    viewBox: "0 0 22.501 22.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDefaultIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/default_icon.0676e78a.svg";
export { ForwardRef as ReactComponent };